import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {EditableLabelWrapping} from 'shells/editable-label/editable-label-wrapping';

import styles from './field-styles.module.css';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    isActive: boolean;
};

export function LabelField(props: Props) {
    const [shouldFocusOnMount, setShouldFocusOnMount] = React.useState<boolean>(props.isActive);
    const color = props.watch(`${props.name}.color`);
    const fontSize = props.watch(`${props.name}.fontSize`);
    const fontWeight = props.watch(`${props.name}.fontWeight`);
    const textAlign = props.watch(`${props.name}.textAlign`);

    return (
        <div className={styles['label-field-container']}>
            <Controller
                name={`${props.name}.label`}
                control={props.control}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <EditableLabelWrapping
                            value={field.value}
                            shouldFocusOnMount={shouldFocusOnMount}
                            onFocusedOnMount={() => setShouldFocusOnMount(false)}
                            onSaveNewValue={(newValue) => {
                                field.onChange(newValue);

                                return new Promise((resolve) => {
                                    // @ts-expect-error
                                    resolve();
                                });
                            }}
                            placeholder='Add a label here'
                            customStyle={{fontSize: `${fontSize}px`, fontWeight, textAlign, color}}
                            errorMessage={errorMessage}
                            isEditableIconVisible={props.isActive}
                        />
                    );
                }}
            />
        </div>
    );
}
